export const S01_DOCUMENT_SLOTS = [
    { id: 'securityPolicy', title: 'Corporate Security & Access Control Policy', domain: 'Physical Security',
        description: 'Security responsibilities, site access, badges, visitor management, and key control.' },
    { id: 'emergencyPlan', title: 'Emergency Action Plan (EAP)', domain: 'Emergency Procedures',
        description: 'Emergency roles, alarms, evacuation, shelter, and response procedures.' },
    { id: 'guardPostOrders', title: 'Guard Force Post Orders & SOPs', domain: 'Guard Force',
        description: 'Guard duties, patrols, handovers, incident reporting, and operating procedures.' },
    { id: 'hrSecurityPolicy', title: 'HR Security & Workplace Violence Policy', domain: 'Employee Controls',
        description: 'Employee security, threat reporting, and prevention and response to workplace violence.' },
] as const;

export type S01DocumentCategory = typeof S01_DOCUMENT_SLOTS[number]['id'];
type CategorizedDocument = { path: string; category?: S01DocumentCategory };

export const s01DocumentCategory = (value: unknown) => S01_DOCUMENT_SLOTS.find(slot => slot.id === value)?.id;
export const s01DocumentTitle = (value: unknown) => S01_DOCUMENT_SLOTS.find(slot => slot.id === value)?.title;
export const cleanS01MissingDocuments = (value: unknown): S01DocumentCategory[] =>
    S01_DOCUMENT_SLOTS.filter(slot => Array.isArray(value) && value.includes(slot.id)).map(slot => slot.id);

export function categorizeS01Documents<T extends CategorizedDocument>(documents: T[], source: unknown): T[] {
    const categories = new Map((Array.isArray(source) ? source : []).map(file => [file?.path, s01DocumentCategory(file?.category)]));
    return documents.map(document => {
        const category = categories.get(document.path);
        return category ? { ...document, category } : document;
    });
}

export const incompleteS01DocumentSlots = (documents: CategorizedDocument[], missing: S01DocumentCategory[]) =>
    S01_DOCUMENT_SLOTS.filter(slot => !missing.includes(slot.id) && !documents.some(document => document.category === slot.id));
export const conflictingS01DocumentSlots = (documents: CategorizedDocument[], missing: S01DocumentCategory[]) =>
    S01_DOCUMENT_SLOTS.filter(slot => missing.includes(slot.id) && documents.some(document => document.category === slot.id));
